<template>
<div class="reservations-table-row-head">
  <div class="-row">
    <div class="-cell" v-bind:style="cellStyle"><slot></slot></div>
  </div>
</div>
</template>


<script>
export default {
  name: 'reservations-table-row-head',
  mixins: [require('mixin/style.vue')],
  props: {
    paddingRight: {
      type: Number,
      default: 10,
    },
    divideLineHeight: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    cellStyle() {
      return this._cellStyle
    },
    _cellStyle() {
      return {
        height: this.height + 'px',
        width: this.width + 'px',
        'text-align': 'right',
        'font-weight': 'bold',
        'line-height': (this.height / this.divideLineHeight) + 'px',
        'border': `0 solid ${this.borderColorDefault}`,
        'border-top-width': this.borderTopWidth + 'px',
        'border-bottom-width': this.borderBottomWidth + 'px',
        'padding-right': this.paddingRight + 'px',
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// head.vue?52390e12